<div class="feature-field">
    <label *ngIf="!hideFieldLabel" class="feature-label" [ngClass]="{ disabled: field.value == null }">
        {{ field.displayName }}
    </label>
    <div class="feature-data image-field-wrapper">
        <div *ngFor="let image of field.value; index as i">
            <a (click)="openLightboxModal(i)" class="pointer">
                <load-img
                    appendClass="{{
                        field.type === FieldType.Signature ? 'attrListItem Signature' : 'attrListItem Image'
                    }}"
                    [thumbnailImageUrl]="getImageUrl(image, thumbnailSwitchOn)"
                    [showOnCondition]="field.value && field.value.length > 0"
                    [authenticate]="false"
                    [imageUrl]="getImageUrl(image)"
                ></load-img>
            </a>
        </div>
    </div>
</div>
